import { z } from 'zod';

import {
  beneficiaryEmailSchema,
  BeneficiarySchemaProps,
} from '../../../../components/BeneficiaryForm/beneficiarySchema';
import locales from './locales';

interface BeneficiaryCardFormSchemaProps extends BeneficiarySchemaProps {
  canResendInvite?: boolean;
}
const beneficiaryCardFormSchema = ({
  canResendInvite,
  initialEmailValue,
  ...props
}: BeneficiaryCardFormSchemaProps) =>
  z.object({
    email: beneficiaryEmailSchema({ initialEmailValue, ...props }).refine(
      (field) =>
        // We want to block someone from resending an invitation to their own email address unless canResendInvite is true
        // We do not want to block them from sending an invitation to a new email address.
        (field === initialEmailValue && canResendInvite) ||
        field !== initialEmailValue,
      {
        message: locales.resendInvitationInputError,
      },
    ),
  });

export type BeneficiaryCardFormSchema = z.input<
  ReturnType<typeof beneficiaryCardFormSchema>
>;

export type BeneficiaryCardFormSchemaValid = z.infer<
  ReturnType<typeof beneficiaryCardFormSchema>
>;

export default beneficiaryCardFormSchema;
